// extracted by mini-css-extract-plugin
export default {"meinian-sales-volume-drop":"index_meinian-sales-volume-drop__am7EX","priceZoneContent":"index_priceZoneContent__fNqxH","newPriceZoneRange":"index_newPriceZoneRange__00v5H"};